import { useBaseStore } from '@roc/feature-app-core';
import { getDashboardRoutes, getDashboardRoutesConfig } from '../routes/dashboardRoutes';
import { getExternalAgentRoutes } from '../routes/externalAgentRoutes';
import { getLoanRoutesConfig } from '@roc/feature-loans-routes-config';
import { getVendorCompanyProfileRoutes, getVendorCompanyProfileRoutesConfig } from '../routes/vendorCompanyProfileRoutes';


export const useExternalAgentRoutes = () => {
  const { globalStore } = useBaseStore();
  const { routeBasePath, routeBaseUrl } = globalStore;
  return {
    titleAgentRoutes: getExternalAgentRoutes(
      routeBasePath,
      routeBaseUrl
    ),
    dashboardRoutes: getDashboardRoutes(
      routeBasePath,
      routeBaseUrl
    ),
    dashboardRoutesConfig: getDashboardRoutesConfig(
      routeBasePath,
      routeBaseUrl
    ),
    externalAgentLoanRoutesConfig: getLoanRoutesConfig(
      routeBasePath,
      routeBaseUrl
    ),
    vendorCompanyProfileConfig: getVendorCompanyProfileRoutesConfig(
      routeBasePath,
      routeBaseUrl
    ),
    vendorCompanyProfile: getVendorCompanyProfileRoutes(
      routeBasePath,
      routeBaseUrl
    )
  };
};
